<template>
  <div>
    <ul>
      <li>Property age: {{ eligibilityCheck.prior1978 ? 'Prior 1978' : 'After 1978' }}.</li>
      <li>Target zip code: {{ getRegion.name }} region.</li>
      <li>Zip code phase-in date: {{ $dayjs(getRegion.startDate).format('MM/DD/YYYY') }}.</li>
      <li>Child under 6: {{ eligibilityCheck.childUnderSix ? 'Yes' : 'No' }}.</li>
      <li>Number of valid certifications: {{ numberOfValidCertifications }} / {{ eligibilityCheck.numberOfUnits }}.</li>
      <li>
        <span v-if="foundLicenseData !== null">
          License (# {{ foundLicenseData.licensenum }})
          was most recently issued on {{ $dayjs(foundLicenseData.mostrecentissuedate).format('MM/DD/YYYY') }},
          and expires on {{ $dayjs(foundLicenseData.expirationdate).format('MM/DD/YYYY') }}.
        </span>
        <span v-else>
          No rental license provided.
        </span>
      </li>
    </ul>
    <p>Lead disclosure submitter contact information.</p>
    <ul>
      <li>Fullname: {{ submitterFullName }}.</li>
      <li>Email: {{ submitter.email }}.</li>
      <li>Phone number: {{ submitter.phoneNumber }}.</li>
      <li v-if="submitter.contactPreference">
        Contact preference: {{ submitter.contactPreference }}.
      </li>
      <li v-if="submitter.jobTitle">
        Job Title: {{ submitter.jobTitle }}.
      </li>
      <li v-if="submitter.companyName">
        Company: {{ submitter.companyName }}.
      </li>
      <li v-if="submitterAddress">
        Address: {{ submitterAddress }}.
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'BasicLeadDisclosureInfo',
  props: {
    eligibilityCheck: {
      type: Object,
      required: true,
    },
    selectedProperty: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    foundLicenseData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    getRegion() {
      return this.$store.getters['properties/getRegion'](this.selectedProperty.zip_code);
    },
    numberOfValidCertifications() {
      return this.eligibilityCheck.nonDraftInspections.filter(i => /Passed|Pending/gi.test(i.status)).length;
    },
    submitter() {
      return this.eligibilityCheck.submitter || false;
    },
    // Submitter Data
    submitterFullName() {
      return String(`${this.submitter.firstName}
        ${this.submitter.middleName || ''}
        ${this.submitter.lastName}`)
        .replace(/\s+(?= )/g,'');
    },

    submitterAddress() {
      if (this.submitter.streetAddress1 === null) {
        return '';
      }
      return String(`${this.submitter.streetAddress1}
        ${this.submitter.streetAddress2 || ''},
        ${this.submitter.city},
        ${this.submitter.state},
        ${this.submitter.country},
        ${this.submitter.zip}`).replace(/\s+(?= )/g,'');
    },
  },
};
</script>

<style>

</style>